import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import { paths } from 'frameworks_drivers/routes';
import { TrackerUtil } from 'tracking/TrackerUtil';
import TitleWithPrevPageLink from 'presentation/components/TitleWithPrevPageLink';
import PageDescription from 'presentation/components/PageDescription';
import { WizardStepsContainer } from 'presentation/components/WizardSteps';
import { useNavigate } from 'react-router-dom';
import useContact from 'tools/hooks/useContact';
import { styled } from 'baseui';

const Clickable = styled('span', {
  cursor: 'pointer'
});

const CentralHeatingMandatoryPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openCall, openEmail } = useContact();

  const handlePrevBtnClicked = () => {
    TrackerUtil.trackPrevBtnClick();
    navigate(paths.CentralHeating);
  };

  return (
    <Container className="pb-4 mb-5">
      <WizardStepsContainer />
      <TitleWithPrevPageLink
        onPrevClick={handlePrevBtnClicked}
        title={t('pageCentralHeatingFallbackTitle')}
      />
      <PageDescription indented>
        <Trans i18nKey="pageCentralHeatingFallbackDescription" />
      </PageDescription>

      <Row className="justify-content-center">
        <Col>
          <p className="copy text-center fw-bold mb-0">
            Telefon:{' '}
            <Clickable onClick={openCall}>{t('headerPhoneSupportViewNumberToDisplay')}</Clickable>
            <br />
            E-Mail:{' '}
            <Clickable onClick={openEmail}>{t('pageCentralHeatingFallbackEMail')}</Clickable>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default CentralHeatingMandatoryPage;
